module.exports = __webpack_public_path__ + "img/sojourner-truth.1ea04402.png";